import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import pages
import { HomePage, ErrorPage } from "./pages";
// import components
import { Head, Contact, Footer, ScrollToTop } from "./components";
import { LocaleProvider } from "./i18n";

// Une même page rendue sous deux URLs distinctes :
//   /    -> français (langue par défaut, x-default)
//   /en  -> anglais
// Chaque URL est prérendue en HTML statique au build (scripts/prerender.js),
// ce qui la rend lisible par les crawlers qui n'exécutent pas de JavaScript.
const Localized = ({ locale, children, head }) => (
  <LocaleProvider locale={locale}>
    {head}
    {children}
    <Contact />
    <Footer />
  </LocaleProvider>
);

const App = () => {
  return (
    <main>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route exact path="/en">
            <Localized locale="en" head={<Head locale="en" />}>
              <HomePage />
            </Localized>
          </Route>
          <Route exact path="/">
            <Localized locale="fr" head={<Head locale="fr" />}>
              <HomePage />
            </Localized>
          </Route>
          <Route path="*">
            <Localized locale="fr">
              <ErrorPage />
            </Localized>
          </Route>
        </Switch>
      </Router>
    </main>
  );
};

export default App;
